import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import AssetManagementListChild from "./AssetManagementListChild";

const AssetManagementList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <AssetManagementListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default AssetManagementList;
